import React from 'react';
import { AddressSection } from './FormComponents';

const RegisteredAddress = ({ formData,handleBlur,errorData, handleChange }) => (
 <div className="card mb-2" style={{ borderRadius: 0 }}>

<div  style={{padding: "8px 15px 3px 11px"}} >
      <AddressSection 
        prefix="registered" 
        formData={formData} 
        handleChange={handleChange} 
        required
        errorData={errorData}
        handleBlur={handleBlur}
      />
    </div>
        </div>

);

export default RegisteredAddress;